import { SectionHeadingContainer } from '@/components/SectionHeadingContainer';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

type CompanyRow = {
  label: string;
  value: string;
  isEmail?: boolean;
};

const companyData: CompanyRow[] = [
  { label: '会社名', value: '株式会社Universe' },
  { label: '所在地', value: '大阪府大阪市北区芝田2-1-18 西阪急ビル' },
  { label: '代表取締役', value: '山中 美樹' },
  { label: '設立', value: '2026年1月16日' },
  { label: '事業内容', value: '営業代行事業 / コンサルティング事業 / 広告マーケティング事業' },
  { label: 'MAIL', value: 'universe.inc42@gmail.com', isEmail: true },
];

export default function CompanySection() {
  const ref = useScrollAnimation();

  return (
    <section
      id="company"
      ref={ref}
      className="relative w-full overflow-hidden"
      style={{ backgroundColor: '#F5F2EB', paddingTop: '65px', paddingBottom: '130px' }}
      aria-label="会社概要"
    >
      {/* 代表メッセージセクションと同じ：左端の薄い縦ライン */}
      <div
        className="pointer-events-none absolute left-0 top-0 bottom-0 w-px opacity-40"
        style={{
          background:
            'linear-gradient(180deg, transparent 0%, rgba(168,205,217,0.5) 20%, rgba(168,205,217,0.5) 80%, transparent 100%)',
        }}
        aria-hidden={true}
      />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-8 lg:px-16">
        {/* 英字ラベル（Message と同一トーン） */}
        <div className="fade-in-up mb-6">
          <span
            className="section-label-en font-montserrat font-light uppercase"
            style={{ color: '#A8CDD9' }}
          >
            COMPANY
          </span>
        </div>

        {/* 見出し：中央・セリフ（Message の h2 と同クラス系統） */}
        <SectionHeadingContainer>
          <h2
            className="section-heading fade-in-up delay-1 mb-12 text-center lg:mb-14"
            style={{
              color: '#1A1A1A',
            }}
          >
            会社概要
          </h2>
        </SectionHeadingContainer>

        {/* 本文ブロック：中央の狭いカラム（max-w-2xl = Message と同じ） */}
        <div className="fade-in-up delay-2 mx-auto max-w-2xl">
          <dl>
            {companyData.map((row) => (
              <div
                key={row.label}
                className="border-b border-solid pb-10 pt-10 first:pt-0"
                style={{ borderColor: 'rgba(168, 205, 217, 0.35)' }}
              >
                <dt
                  className="mb-2 text-xs font-light tracking-[0.12em] sm:text-sm"
                  style={{
                    color: '#A8CDD9',
                    fontFamily: "'Noto Sans JP', sans-serif",
                    fontWeight: 300,
                  }}
                >
                  {row.label}
                </dt>
                <dd
                  className="text-sm font-light leading-[2.35] lg:text-base"
                  style={{
                    color: '#3A3A3A',
                    fontFamily: "'Noto Sans JP', sans-serif",
                    fontWeight: 300,
                  }}
                >
                  {row.label === '会社名' ? (
                    <strong className="font-medium" style={{ color: '#B89B4A' }}>
                      {row.value}
                    </strong>
                  ) : row.isEmail ? (
                    <a
                      href={`mailto:${row.value}`}
                      className="break-all font-medium transition-colors duration-300 hover:underline"
                      style={{ color: '#B89B4A' }}
                    >
                      {row.value}
                    </a>
                  ) : (
                    row.value
                  )}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
